/** @format */

export const studentRoutes = {
    continueWithoutLogin: 'student.search',
    defaultView: 'student.logged-in.frontpage',
    loggedIn: 'student.logged-in.**',
    login: 'student.login',
};
